const ecpRoutes = [
  {
    path: "/ecp",
    name: "",
    meta: {
      title: "비교과",
      isDynamic: false,
    },
    children: [
      /** 1. 비교과 신청 */
      {
        path: "apply", // /ecp/apply
        name: "ecpApplyIndex",
        meta: {
          title: "비교과 신청",
          titleEn: "Extracurricular Activities Apply",
          menuCd: "STUDENT_ECP_APPLY",
          isDynamic: false,
          // site: "inha",
        },
        //@only_inha
        // component: () => import("@/views/student/ecp/apply/EcpApplyIndex-inha.vue"),
        component: () => import("@/views/student/ecp/apply/EcpApplyIndex.vue"),
      },
      /** 2. 비교과 상세 */
      {
        path: "detail/:ecpId", // /ecp/detail/:ecpId
        name: "ecpDetail",
        meta: {
          title: "비교과 신청 상세",
          mobileTitle: "비교과 신청",
          titleEn: "Extracurricular Activities Apply Detail",
          menuCd: "STUDENT_ECP_APPLY",
          isDynamic: false,
          mobileHd: true,
          likeBtn: true,
          // site: "inha",
        },
        //@only_inha
        // component: () => import("@/views/student/ecp/apply/EcpDetail-inha.vue"),
        component: () => import("@/views/student/ecp/apply/EcpDetail.vue"),
      },

      /** 3. 나의 비교과 */
      {
        path: "my-ecp",
        name: "myEcp",
        children: [
          /* 3-1. 나의 비교과 */
          {
            path: "", // /ecp/my-ecp
            name: "myEcpIndex",
            meta: {
              title: "나의 비교과",
              titleEn: "My Extracurricular Activities",
              menuCd: "STUDENT_MY_ECP",
              isDynamic: true,
            },
            component: () =>
              import("@/views/student/ecp/my-ecp/MyEcpIndex.vue"),
          },
          /* 3-2. 강의실 */
          {
            path: "classroom", // /ecp/my-ecp/classroom
            name: "myEcpClassroom",
            meta: {
              title: "강의실",
              titleEn: "Classroom",
              menuCd: "STUDENT_MY_ECP",
              isDynamic: true,
            },
            component: () =>
              import("@/views/student/ecp/my-ecp/MyEcpClassroomIndex.vue"),
          },
        ],
      },
      /** 4. 평생교육 @only_inha */
      {
        path: "lifelong-edu", // /ecp/lifelong-edu
        name: "lifelongEdu",
        meta: {
          title: "평생교육",
          titleEn: "Lifelong Education",
          menuCd: "STUDENT_LIFELONG",
          isDynamic: true,
        },
        component: () =>
          import("@/views/student/ecp/lifelong-edu/LifelongEduIndex.vue"),
      },
      /** 5. AI추천 비교과 @only_dist */
      {
        path: "ai-recommend", // /ecp/ai
        name: "aiRecommend",
        meta: {
          title: "AI 추천 비교과",
          titleEn: "AI Recommended Extracurricular Activities",
          menuCd: "ECP_AI_RECOMMEND",
          isDynamic: true,
        },
        component: () =>
          import("@/views/student/ecp/ai-recommend/EcpAiRecommendIndex.vue"),
      },
    ],
  },
];
export default ecpRoutes;
